module.exports = __webpack_public_path__ + "static/13-8e28bf859fc75690d1d188c19358ba74.png";